document.addEventListener('alpine:init', () => {
  Alpine.data('HeaderGroups', () => ({
    cache: {},
    headers_brands: [],
    headers: [],
    current_header_id: '',
    init() {
      this.InitCache();
      this.InitSelf();
    },
    InitCache() {
      let am = this;
      am.cache.$headers = am.$el.querySelectorAll('header-wrap');
    },
    InitSelf() {
      let am = this;
      am.headers_brands = [...am.cache.$headers].map($item => $item.dataset.brand);

      // set header settings
      am.headers = [...am.cache.$headers].map(($header_item, index) => {
        let setting = JSON.parse($header_item.dataset.headerSettings);
        setting.id = am.headers_brands[index];
        setting.color_scheme_class = `color-scheme--${$header_item.dataset.headerColorScheme}`;
        return setting;
      });

      // get current header from metafield, if not preset to first brand
      let preset_header_brand = am.$el.dataset.brand;
      am.current_header_id = preset_header_brand || am.headers_brands[0];

      am.$el.removeAttribute('x-cloak-header');
    },
    e_SetCurrentHeader(e, header_id) {
      let am = this;
      am.current_header_id = header_id;
    }
  }));
});